import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  needHelpButtonText: {
    id: 'needHelp',
    description: 'Need help button text',
    defaultMessage: 'Need Help?'
  },

  cateringOrderPendingApproval: {
    id: 'cateringOrderPendingApproval',
    description: 'Message telling user when their catering order is pending approval',
    defaultMessage: "Your order is currently pending. You'll receive an email once it's accepted."
  },

  couldNotLocateStore: {
    id: 'couldNotLocateStore',
    description: 'Message telling the user that store could not be located to complete their order',
    defaultMessage: 'The store could not be located to complete your order. Please try again later.'
  },

  moreItems: {
    id: 'moreItems',
    description: 'More items',
    defaultMessage:
      '{remainingItems, plural, =0 {} other {{remainingItems}}} {remainingItems, plural, =0 {} one {more item…} other {more items…}}'
  },

  startOrder: {
    id: 'startOrder',
    defaultMessage: 'Start Order',
    description: 'Link to start their order'
  },

  noOrdersItemsYet: {
    id: 'noOrdersItemsYet',
    defaultMessage: 'RECENT ORDERS & ITEMS WILL APPEAR HERE',
    description: 'Placeholder text for recent orders and items'
  },

  noOrderYet: {
    id: 'noOrderYet',
    defaultMessage: 'Orders will appear here',
    description: 'Placeholder text for recent orders'
  },

  recentOrders: {
    id: 'recentOrders',
    defaultMessage: 'Recent Orders',
    description: 'Header for recent orders'
  },

  recentOrdersDisclaimer: {
    id: 'recentOrdersDisclaimer',
    defaultMessage: 'Prices, discounts and availability are subject to change when you reorder.',
    description: 'Text for disclaimer'
  },

  recentOrdersEmptySubHeader: {
    id: 'recentOrdersEmptySubHeader',
    defaultMessage: 'Go start a new order now!',
    description: 'Header text for starting a new order'
  },

  refreshOrders: {
    id: 'refresh',
    defaultMessage: 'Refresh',
    description: 'CTA text for refreshing Orders'
  },

  /* details-modal.tsx */
  dineIn: {
    id: 'dineIn',
    defaultMessage: 'Dine in',
    description: 'Text for dine in'
  },

  pickUp: {
    id: 'pickUp',
    defaultMessage: 'Pick Up',
    description: 'Text for pickup'
  },

  driveThru: {
    id: 'driveThru',
    defaultMessage: 'Drive Thru',
    description: 'Text for drive through'
  },

  delivery: {
    id: 'delivery',
    defaultMessage: 'Delivery',
    description: 'Text for delivery'
  },

  curbside: {
    id: 'curbside',
    defaultMessage: 'Curbside',
    description: 'Text for curbside pickup'
  },

  orderNumber: {
    id: 'orderNumber',
    defaultMessage: 'Order number',
    description: 'Label text for order number'
  },

  orderTime: {
    id: 'orderTime',
    defaultMessage: 'Order time',
    description: 'Label text for order time'
  },

  method: {
    id: 'method',
    defaultMessage: 'Method: {serviceMode}',
    description: 'Label for order method'
  },

  pickUpTime: {
    id: 'pickUpTime',
    defaultMessage: 'Pick up time',
    description: 'Label for pickup time'
  },

  location: {
    id: 'location',
    defaultMessage: 'Location',
    description: 'Label for order location'
  },

  deliveryFee: {
    id: 'deliveryFee',
    defaultMessage: 'Delivery Fee',
    description: 'Text label for delivery fee'
  },

  free: {
    id: 'free',
    defaultMessage: 'FREE',
    description: 'Text for free delivery'
  },

  tip: {
    id: 'tip',
    defaultMessage: 'Tip',
    description: 'Text for driver tip'
  },

  subtotal: {
    id: 'subtotal',
    defaultMessage: 'Subtotal',
    description: 'Text for user subtotal'
  },

  total: {
    id: 'total',
    defaultMessage: 'Total',
    description: 'Text for users total'
  },

  trackOrder: {
    id: 'trackOrder',
    defaultMessage: 'Track order',
    description: 'Button for user to track their order'
  },

  reorder: {
    id: 'reorder',
    defaultMessage: 'Reorder',
    description: 'Button for user to reorder'
  },

  pricesDiscountsAndAvailabilityAreSbujectToChangeWhenYouReorder: {
    id: 'pricesDiscountsAndAvailabilityAreSbujectToChangeWhenYouReorder',
    defaultMessage: 'Prices, discounts and availability are subject to change when you reorder.',
    description: 'Text for disclaimer'
  },

  localeDateTime: {
    id: 'localeDateTime',
    defaultMessage: 'en-US',
    description: 'This specifies the language type for a locale string'
  },

  tax: {
    id: 'tax',
    defaultMessage: 'Tax',
    description: 'Text string labeling the tax amount'
  },

  item: {
    id: 'item',
    defaultMessage: 'Item',
    description: 'Text string referring to items ordered (singular)'
  },

  items: {
    id: 'items',
    defaultMessage: 'Items',
    description: 'Text string referring to items ordered (plural)'
  },

  orderDetailsHeading: {
    id: 'orderDetailsHeading',
    defaultMessage: 'Order Details',
    description: 'Heading for order details'
  },

  rewards: {
    id: 'rewards',
    defaultMessage: 'Rewards',
    description: 'Heading for rewards section'
  },

  viewDetails: {
    id: 'viewDetails',
    defaultMessage: 'View Details',
    description: 'Button to view order details'
  },

  recentItems: {
    id: 'recentItems',
    defaultMessage: 'Recent Items',
    description: 'Header for Recent Items section'
  },

  serviceFee: {
    id: 'serviceFee',
    defaultMessage: 'Service Fee',
    description: 'Text label for Service Fee'
  },

  smallCartFee: {
    id: 'smallCartFee',
    defaultMessage: 'Small Cart Fee',
    description: 'Text label for Small Cart Fee'
  }
});
